import ReactFinalForm from 'components/form/ReactFinalForm';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { useEffect, useState } from 'react';
import { tenantSettingsService } from 'services/api';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText
} from '@mui/material';
import MailOutline from '@mui/icons-material/MailOutline';

interface ShowEmailParams {
  open;
  onClose;
  order_id?: number;
  onSubmit: (text) => void;
}
function ShowOrderEmailDialog(params: ShowEmailParams) {
  const translationPrefix = 'pages.orders.show-email';
  const { t } = useTranslation();
  const { order_id, open, onClose, onSubmit } = params;

  const [emailBody, setEmailBody] = useState<string>();
  const [emailCC, setEmailCC] = useState<string>();

  useEffect(() => {
    tenantSettingsService.get(1).then((res) => {
      setEmailBody(res.orders_default_email_body);
      const emailCC = [res.cc_orders]
        .filter(Boolean)
        .map((item) => item.replace(/;/g, ' '))
        .join(' ');
      setEmailCC(emailCC);
    });
  }, [order_id]);

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth onClose={onClose}>
      <DialogTitle>{t(`${translationPrefix}.title`)}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t(`${translationPrefix}.subtitle`)}</DialogContentText>

        <ReactFinalForm onSubmit={handleSubmit} formId="sendEmailOrder" hideControls>
          {/* Potrebbe non servire */}
          {/* <div className="w-full p-4">
            <IdentityField
              name="email_recipient"
              component={TextFieldAdapter}
              label={t('global.recipient')}
              placeholder={t('global.recipient-placeholder')}
              initialValue={''}
              type="text"
            />
          </div> */}
          <div className="w-full p-4">
            <IdentityField
              name="email_cc"
              component={TextFieldAdapter}
              label={t('global.cc')}
              initialValue={emailCC ? emailCC : ''}
              type="text"
            />
          </div>
          <div className="w-full p-4">
            <IdentityField
              name="email_body"
              component={TextFieldAdapter}
              label={t('global.message')}
              placeholder={t('global.message-placeholder')}
              initialValue={emailBody ? emailBody : ''}
              type="text"
              multiline
              rows={4}
            />
          </div>
        </ReactFinalForm>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          {t('actions.cancel')}
        </Button>
        <Button type="submit" form="sendEmailOrder">
          {t(`actions.confirm`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ShowOrderEmailDialog;
